import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  target: string;
};

/**
 * Ako prihlásený občan stojí na jednom podnete: `active_tokens` je počet jeho
 * hlasov na tomto podnete (nenulové = už hlasoval), `available_tokens` zvyšok
 * celého jeho fondu.
 */
export const meGetTargetVoteTokens = createQueryFn(
  QueryNameSpace.meGetTargetVoteTokens,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    if (!params) {
      throw new Error('Provide required parameters!');
    }

    return await DigiobcanApi.meGetTargetVoteTokens(params.target);
  },
);
